import React from "react";
import Container from "@material-ui/core/Container";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import {Paper} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import TimeAgo from "react-timeago/lib";

import {API_BASE, BACKEND_SERVER} from "../logic/StageClient";

const API_GET_TWEETS_QUEUE = BACKEND_SERVER + API_BASE + '/rest/queues';

const useLocalStyles = makeStyles(() => ({
  infoCard: {
    background: '#efe8ed',
  },
  table: {
    color: 'blue',
  },
}));

/**
 * This is here for debug purposes only
 */
export function ViewAdminQueues() {
  const classes = useLocalStyles();

  const [tweetQueue, setTweetQueue] = React.useState<StageTypes.RankedTweet[]>([]);
  const [timeStamp, setTimeStamp] = React.useState<number>(0);

  React.useEffect(() => {
    fetch(API_GET_TWEETS_QUEUE)
      .then(results => results.json())
      .then(r => {
        setTweetQueue(r.trendsQueue);
        setTimeStamp(r.ts);
      })
      .catch(e => console.log(e));
    return () => {
    };
  }, []);

  const rows = tweetQueue.map((rt: StageTypes.RankedTweet) => {
    return {
      id: rt.tweet.id,
      trend: rt.trendName,
      user: rt.tweet.username,
      text: rt.tweet.cleanText,
      dirtyText: rt.tweet._orig_text,
      used: rt.used_count,
      score: rt.score_queue,
      score_trend: rt.score_trend,
      score_tweet: rt.score_tweet,
    };
  });

  const colNames = ['#', 'ID', 'Trend', 'User', 'Text', 'Used↓', 'S↑', 'ST', 'SW',];

  return (
    <Container maxWidth="xl" style={{margin: '3em 0'}}>
      <Typography variant={"h4"}>Tweets queue</Typography>
      <Typography style={{margin: '1em 0'}}>
        The following are the tweets in order of next emission. See the 'Used' counter for how much
        a single tweet has been discussed already. The ranking of the tweets goes up by usage, down by score.
        For debugging proposes only.
      </Typography>
      {timeStamp && <Typography>
        Last update: <TimeAgo date={timeStamp * 1000} minPeriod={1}/>.
        Next update: <TimeAgo date={(timeStamp + 60) * 1000} minPeriod={1}/>.
      </Typography>}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {colNames.map((name, idx) => <TableCell key={'col-' + idx} align={idx > 5 ? "center" : "left"}>{name}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">{idx}</TableCell>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.trend}</TableCell>
                <TableCell>{row.user}</TableCell>
                <TableCell>{row.text}</TableCell>
                <TableCell align="center">{row.used}</TableCell>
                <TableCell align="center">{Math.round(row.score * 100) / 100}</TableCell>
                <TableCell align="center">{Math.round(row.score_trend * 100) / 100}</TableCell>
                <TableCell align="center">{Math.round(row.score_tweet * 100) / 100}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
